export const PlusSvg = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="4.20001" y1="14" x2="23.8" y2="14" stroke-width="2.8" />
      <line x1="14" y1="23.8" x2="14" y2="4.19999" stroke-width="2.8" />
    </svg>
  );
};

export const MinusSvg = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="4.20001" y1="14" x2="23.8" y2="14" stroke-width="2.8" />
    </svg>
  );
};

export const TrashIcon = ({ className }: { className: string }) => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.1621 2.78254C10.1621 2.29512 10.5735 1.89999 11.0809 1.89999H16.9192C17.4266 1.89999 17.8379 2.29512 17.8379 2.78254C17.8379 3.26996 17.4266 3.66509 16.9192 3.66509H11.0809C10.5735 3.66509 10.1621 3.26996 10.1621 2.78254Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.82842 5.6129H22.1715C23.0709 5.6129 23.8 6.31035 23.8 7.1707C23.8 8.03105 23.0709 8.7285 22.1715 8.7285H5.82842C4.92904 8.7285 4.19995 8.03105 4.19995 7.1707C4.19995 6.31035 4.92904 5.6129 5.82842 5.6129Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.4671 6.50722C21.9745 6.50722 22.3859 6.90235 22.3859 7.38977V23.194C22.3859 25.1733 20.9733 27.1 18.8836 27.1H9.28937C7.19967 27.1 5.78707 25.1733 5.78707 23.194V11.966C5.78707 11.4786 6.19841 11.0835 6.70582 11.0835C7.21323 11.0835 7.62457 11.4786 7.62457 11.966V23.194C7.62457 24.5404 8.53716 25.3349 9.28937 25.3349H18.8836C19.6358 25.3349 20.5484 24.5404 20.5484 23.194V7.38977C20.5484 6.90235 20.9597 6.50722 21.4671 6.50722Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1026 12.2581C12.61 12.2581 13.0213 12.6533 13.0213 13.1407V22.7149C13.0213 23.2023 12.61 23.5974 12.1026 23.5974C11.5951 23.5974 11.1838 23.2023 11.1838 22.7149V13.1407C11.1838 12.6533 11.5951 12.2581 12.1026 12.2581Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8977 12.2581C16.4051 12.2581 16.8164 12.6533 16.8164 13.1407V22.7149C16.8164 23.2023 16.4051 23.5974 15.8977 23.5974C15.3903 23.5974 14.9789 23.2023 14.9789 22.7149V13.1407C14.9789 12.6533 15.3903 12.2581 15.8977 12.2581Z"
      />
    </svg>
  );
};

export const DeleteIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <line
        x1="5.05037"
        y1="5.05028"
        x2="14.9499"
        y2="14.9498"
        stroke="#666666"
        stroke-width="2"
      />
      <line
        x1="5.05022"
        y1="14.9498"
        x2="14.9497"
        y2="5.05026"
        stroke="#666666"
        stroke-width="2"
      />
    </svg>
  );
};

export const CheckoutSuccessIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="24" fill="#2B43DA" />
      <path
        d="M14 23.8909L19.8065 30L34 18"
        stroke="#F5F5F5"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
